// Interface
import util from '@/utils/classToObject'
import { ILayermapState } from './state'

export class LayermapGetter {  
        

  public depthProfile(state:ILayermapState) {
    return state.depthProfile
  }

  public depthProfileLoading(state:ILayermapState) {
    return state.depthProfileLoading
  }

  public depthProfileProvider(state:ILayermapState) {
    return state.depthProfileProvider
  }
  
}

export default util.classToObject(LayermapGetter)